<template>
    <action>
        <template slot="header">App Gruppenbild</template>

        <loading v-show="loading"></loading>

        <div class="mb-2" v-show="!loading">
            App Gruppenbild:
            <input type="file" ref="header" @change="handleFileUpload()" class="border" accept=".png,.jpg,.jpeg">
        </div>

        <img v-show="group.app_header" :src="group.app_header" alt="App Gruppenbild" class="mb-4">

        <confirm-dialog @confirmed="removeMap" v-show="group.app_header">
            <button-delete><i class="fa fa-trash"></i> Gruppenbild löschen</button-delete>
            <template slot="header">Gruppenbild löschen</template>
            <template slot="question">Soll das Gruppenbild wirklich gelöscht weden?</template>
            <template slot="confirm"><button-delete><i class="fa fa-trash"></i> Löschen</button-delete></template>
        </confirm-dialog>

    </action>
</template>

<script>
import Action from "../UI/Action.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import Loading from "../UI/Loading.vue";
import ConfirmDialog from "../UI/ConfirmDialog.vue";
import ButtonDelete from "../UI/ButtonDelete.vue";

export default {
    name: "AppHeader",

    components: {ButtonDelete, ConfirmDialog, Loading, ButtonPrimary, Action},

    inject: ['group'],

    data:() => ({
        loading: false,
    }),

    methods: {
        handleFileUpload() {
            this.loading = true;
            let header = this.$refs.header.files[0];
            let formData = new FormData();
            formData.append('app_header', header);
            window.axios
                .post(`/admin/group`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(() => {
                    location.reload();
                    this.loading = false;
                    this.$root.$emit('alert', 'Neues Gruppenbild gespeichert.');
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
        removeMap() {
            this.loading = true;
            window.axios.post(`/admin/group`, {
                app_header: '',
            }).then(() => {
                location.reload();
                this.loading = false;
                this.$root.$emit('alert', 'Gruppenbild gelöscht.');
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
    }
}
</script>

<style scoped>

</style>